import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";

export function useLimits(step = 30) {
  const [map, setMap] = useState({});
  const lim = (k) => map[k] || step;
  const more = (k) => setMap((p) => ({ ...p, [k]: (p[k] || step) + step }));
  return { lim, more, step };
}

export const ShowMore = ({ shown, total, onMore, label = "data", testid }) => {
  if (total <= shown) return null;
  return (
    <div className="flex justify-center py-2.5 bg-muted/20">
      <Button variant="outline" size="sm" className="h-8 text-xs gap-1.5" onClick={onMore} data-testid={testid}>
        <ChevronDown className="h-3.5 w-3.5" /> Tampilkan lebih banyak ({shown} dari {total} {label})
      </Button>
    </div>
  );
};
